import { render } from "./PaymentsList.vue?vue&type=template&id=0d469ee0&ts=true"
import script from "./PaymentsList.vue?vue&type=script&lang=ts"
export * from "./PaymentsList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__